module.exports = require("@mui/material/TableBody");